<spinner *ngIf="spinner" [center]="true" [selfSpin]="true" size="la-2x" color="grey" type="ball-triangle-path">
</spinner>

<div  class="input-container" fxLayout="row"
  fxLayoutAlign="start center">
  <mat-form-field class="form-field" fxFlex="80%" fxFlex.lt-sm="100%">
    <!-- <mat-icon color="primary" matPrefix>event</mat-icon> -->
    <mat-label>
      <span>Select</span>
    </mat-label>

    <div class="input-row" fxLayout="row" fxLayoutAlign="start center">
      <input matInput #actionInput [formControl]="systemObjectsListingACFrom" (focus)="setStepFilterOptions()"
        [matAutocomplete]="autoBoxEvent" />
    </div>

    <button *ngIf="systemObjectsListingACFrom.value" matTooltip=""
      matSuffix mat-icon-button aria-label="Clear"
      (click)="systemObjectsListingACFrom.patchValue('');$event.stopPropagation();"
      class="clear-icon-button">
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoBoxEvent="matAutocomplete" [displayWith]="displayFunction"
      (optionSelected)="systemObjectSelected($event.option.value);" class="autocomplete">
      <mat-option *ngFor="let option of systemObjectsOptions | async; trackBy: trackByFn" [value]="option" class="autocomplete-option" fxLayout="row" fxLayoutAlign="center center">
        <div class="option-content" fxLayout="row" fxLayoutAlign="center center">
          <span class="option-text"> {{ option.name }} </span>
        </div>
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="systemObjectsListingACFrom?.errors?.errorMsg">
      {{ systemObjectsListingACFrom.errors.errorMsg }}
    </mat-error>
  </mat-form-field>
  <mat-spinner *ngIf="spinner" color="warn" [diameter]="20"></mat-spinner>
</div>
